var map = {
	"./bandcamp.svg": 841,
	"./bluesky.svg": 438,
	"./gamepad.svg": 364,
	"./instagram.svg": 373,
	"./music.svg": 504,
	"./patreon.svg": 610,
	"./reddit.svg": 947,
	"./snowflake.svg": 65,
	"./tiktok.svg": 301,
	"./twitter.svg": 592,
	"./youtube.svg": 54
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 669;